import { Button, Form, Input, message, Select } from 'antd';
import { NewModal } from '../NewModal';
import { useUser } from "../../hooks/useUsers";
import { Option } from 'antd/lib/mentions';
import { useNavigate } from 'react-router-dom';
import { useCompanies } from '../../hooks/useCompanies';
import { useLogged } from '../../hooks/userLogin';
import { useState, useEffect } from 'react';
import FormItem from 'antd/lib/form/FormItem';

interface ICompany {
  id: string;
  name: string;
  document: string;
  description: string;
  primary_color: string;
  secondary_color: string;
  logo: string;
  created_by?: string;
}

export function NewUserModal() {
    const navigate = useNavigate();
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [filteredCompanies, setFilteredCompanies] = useState<ICompany[]>([]);
    const [loadingCompanies, setLoadingCompanies] = useState(false);

    const {
      user
    } = useLogged();

    const {
      fetchUsers,
      roles,
      createUser,
      handleModalVisible,
      isNewModalVisible,
    } = useUser();

    const {
      companies,
      fetchAllCompanies
    } = useCompanies();

    const handleCancel = () => {
      handleModalVisible(false);
    };

    const handleCompanySearch = async (value: string) => {
      setSearchValue(value);
      setLoadingCompanies(true);
      
      try {
        const companies = await fetchAllCompanies(value);
        setFilteredCompanies(companies);
      } catch (error) {
        console.error('Erro ao buscar empresas:', error);
      } finally {
        setLoadingCompanies(false);
      }
    };

    const availableRoles = user.company_id
      ? roles.filter(role => role.company_id === user.company_id)
      : roles.filter(role => role.company_id === selectedCompanyId);

    const handleOk = () => { };

    // Carregar empresas iniciais quando o modal abrir
    useEffect(() => {
      if (isNewModalVisible && !user.company_id) {
        handleCompanySearch('');
      }
    }, [isNewModalVisible, user.company_id]);

    return (
        <NewModal
            buttonModalText={"Abra o modal"}
            visible={isNewModalVisible}
            handleCancel={handleCancel}
            handleOk={handleOk}
            title="Novo Usuário"
        >
            <Form
                onFinish={async (form) => {
                    const status = await createUser(form);

                    if (status) message.success("Aprovado");
                    else message.warning("Falha");

                    handleModalVisible(false);
                    fetchUsers(1, 'asc', 'name');
                    navigate('/users/1')
                }}
            >
                <Form.Item
                    name="name"
                    label="Nome"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                >
                    <Input maxLength={50} placeholder="Nome do usuário!" />
                </Form.Item>

                <Form.Item
                    name="email"
                    label="E-mail"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                        {
                            type: "email",
                            message: "Esse campo é um email",
                        },
                    ]}
                >
                    <Input maxLength={50} placeholder="Senha" />
                </Form.Item>

                <Form.Item
                    name="password"
                    label="Senha"
                    style={{
                        marginBottom: "25px",
                    }}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                >
                    <Input type="password" maxLength={50} placeholder="Senha" />
                </Form.Item>

                <Form.Item
                    name="passwordConfirmation"
                    label="Confirmação"
                    dependencies={["password"]}
                    hasFeedback
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error("As duas senhas precisam ser iguais!")
                                );
                            },
                        }),
                    ]}
                >
                    <Input
                        type="password"
                        maxLength={50}
                        placeholder="Confirme sua senha!"
                    />
                </Form.Item>

                {
                  !user.company_id
                  ? (
                    <FormItem
                        name="company_id"
                        label="Empresa"
                        style={{
                            marginBottom: "25px",
                        }}
                        rules={[
                            {
                                required: false,
                                message: "Este campo é obrigatório!",
                            },
                        ]}
                    >
                        <Select
                            placeholder="Digite para buscar a empresa!"
                            onChange={(value) => setSelectedCompanyId(value)}
                            onSearch={handleCompanySearch}
                            showSearch
                            loading={loadingCompanies}
                            filterOption={false}
                            style={{ width: "100%" }}
                            notFoundContent={loadingCompanies ? "Buscando..." : "Nenhuma empresa encontrada"}
                        >
                            {filteredCompanies.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                    </FormItem>
                  )
                  : null
                }

                <FormItem
                    name="role_id"
                    label="Grupo"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                >
                    <Select
                        placeholder="Selecione o grupo!"
                        onChange={() => { }}
                        style={{ width: "100%" }}
                    >
                        {availableRoles.map((item) => (
                            <Option key={item.id}>{item.name}</Option>
                        ))}
                    </Select>
                </FormItem>

                <FormItem style={{ paddingLeft: "63%" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                    >
                      Salvar
                    </Button>
                    <Button
                      onClick={() => handleModalVisible(false)}
                    >
                      Cancelar
                    </Button>
                </FormItem>
            </Form>
        </NewModal>
    );
}
